import React, { useEffect, useState } from 'react';
import { ProjectSelector } from '../HelperComponentsMain/ProjectsInfo';
import SiteGameModal from './HelperComponentsProj/SiteGameModal';

function Games({proj, projData, modal, toggle}) {
    const [site, setSite] = useState(0);
    const [selType, setSelType] = useState("VN");

    // async function fetchData(query, type) {
    //     await fetch('/api/projects', {
    //         method: 'post',
    //         body: JSON.stringify({query, type}),
    //         headers: {
    //             'Content-Type': 'application/json',
    //             'Accept': 'application/json'
    //         }
    //     })
    //         .then(res => res.json())
    //         .then(data => {
    //             setSelType(data);
    //         })
    //         .catch(err => console.error(err));
    // }

    // useEffect(() => {
    //     (async function() {
    //         await fetchData("games", "VN");
    //     })();
    // }, []);

    useEffect(() => {
        function arrowKeys(e) {
            switch(e.code) {
                case "ArrowLeft":
                    handleNext(1);
                    break;

                case "ArrowRight":
                    handleNext(0);
                    break;

                default: return;
            }
        }

        window.addEventListener('keydown', arrowKeys);

        return () => window.removeEventListener('keydown', arrowKeys);
    });

    function handleNext(num) {
        if (num === 0 && site === 0) return setSite(selType.length-1);
        else if (num === 1 && site === selType.length-1) return setSite(0);

        if (num === 0) setSite(site - 1);
        else if (num === 1) setSite(site + 1);
    }

    async function handleActive(e) {
        setSite(0)
        let elm;
        e.currentTarget.id ? elm = e.currentTarget.id : elm = e.currentTarget.parentNode.id;
        // Remember to setup a default incase the folder doesn't exist in the DB.

        // await fetchData('games', elm);
        setSelType(elm);
    }

    return (
        <React.Fragment>
            <ProjectSelector
                proj={"games"}
                projName={"Games"}
                projData={projData}
                modal={modal}
                toggle={toggle}
                selType={selType}
                setSite={setSite}
                HandleActive={handleActive}
            />
            <SiteGameModal
                modal={modal}
                toggle={toggle}
                proj={proj}
                projData={projData}
                site={site}
                setSite={setSite}
                selType={selType}
                HNS={handleNext}
            />
        </React.Fragment>
    );
}

export default Games